// @ds/editable/editableGroupContext — batch-edit group context.
//
// Provided by EditableGroup. Allows Editable children to participate in
// batch-edit: enter edit mode when the group opens, commit or discard
// when the group saves/cancels.
//
// Split out of `Editable.tsx` so that module exports components only.
import { createContext } from "react";

export interface GroupEditCtx {
  editing: boolean;
  /** Increments each time the group saves. Children compare against their
   *  lastSaveCount ref to distinguish save from cancel on group close. */
  saveCount: number;
}

export const EditableGroupContext = createContext<GroupEditCtx>({
  editing: false,
  saveCount: 0,
});
